import React, { Component } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Identity from './FormSteps/Identity.jsx'
import { FormContainer } from '../Form'
import {
    isEmptyString,
} from '../../../../../../helpers/sanityChecks'
import {
    isDateValid,
    validateFields,
} from '../../../../../../helpers/collaborativeIndexations'
import EventDate from "./FormSteps/EventDate";

class NominativeWithDateForm extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.formSteps = [
            Identity,
            EventDate
        ]

        this.formStepsValidation = {
            2: () => {
                validateFields({
                    lastname: () => ! isEmptyString(this.props.fields.lastname),
                })
            },
            3: () => {
                validateFields({
                    eventDate: () => this.props.fields.eventDate === null || isDateValid(this.props.fields.eventDate),
                })
            }
        }
    }

    render()
    {
        return (
            <FormContainer steps={ this.formSteps } stepsValidation={ this.formStepsValidation } />
        )
    }
}

export default withTranslation()(NominativeWithDateForm)
